import React from "react";
import "./index.scss";

function Hero() {
  return <div className="Hero" />;
}

export default Hero;
